/**
 * Versión actual de la aplicación
 * Sprint 6: Se lee de variable de entorno configurada en build time
 *
 * Para actualizar antes de un release:
 *   1. Cambiar "version" en package.json
 *   2. Cambiar VITE_APP_VERSION en .env
 *   3. npm run build && npx cap sync android
 */

export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION || '1.0.0';
